<template>
	<div>
		<div class="row mb-2">
			<div class="col-8">
				<h1>{{$t('osce-dashboard')}}</h1>
			</div>
			<div class="col-4 text-right d-flex align-items-center justify-content-end">
				<button
					v-if="isOsceAdmin && stations[selectedStation]"
					class="btn btn-secondary"
					@click="openTimer(stations[selectedStation])"
				>
					<b-icon icon="stopwatch"></b-icon> {{ $t('timer') }}
				</button>
				<button
					v-if="stations[selectedStation] && stations[selectedStation].form_id"
					class="btn btn-secondary ml-2"
					@click="openRubric(stations[selectedStation])"
				>
					<b-icon icon="eye"></b-icon> {{ $t('view-rubric') }}
				</button>
			</div>
		</div>
		<div class="row">

			<div class="col-12 col-lg-12 order-lg-1">
				<template v-if="ready">
					<template v-if="stations.length">
						<TabbedView v-if="ready" @selectedIndexChanged="selectStation">
						
							<template v-slot:before-nav>
								<h1>{{ $t('messages') }}</h1>
								<div class="card mb-8">
									<OSCEChat 
										@new-message="handleNewMessage"
										:canCleanUpNotifications="true"
									/>
								</div>
    						</template>
    						
							<TabbedViewTab v-for="(station, stationIndex) in stations" :title="`${station.code}: ${station.title}`"
								:id="stationIndex.toString()" :key="stationIndex">
								<Table
									:loading="loading"
									:submitting="submitting"
									:cols="[
										{ key: 'student_id', heading: $t('id'), size: 2 },
										{ key: 'student_displayName', heading: $t('name'), size: 3 },
										{ key: 'examiner_displayName', heading: $t('examiner'), size: 3 },
										{ key: 'status', heading: $t('status'), size: 4, icon: (item) => statusIcon(item.status), cb: (item) => statusText(item) }
									]"
									:data="visibleStudents"
									breakpoint="md"
									:filters="{
										...filters,
										page: filters.page,
										page_size: filters.page_size,
										total_count: total_count
									}"
									:scrollPaginate="true"
									@refresh="refresh"
									:searchable="true"
									class="mb-4"
									@selectItem="chooseStudent"
								>
									<!-- Table Header -->
									<template v-slot:header>
										<div class="list-group-item align-items-center">
					
											<div class="btn-group">
												<button
													v-for="option in statusfilteroptions"
													:key="option.key"
													@click="filters.status = option.key; setVisibleStudents()"
													class="btn"
													:class="{ 'btn-primary': filters.status == option.key, 'btn-light': filters.status != option.key }"
												  >
													{{ option.label }}
												</button>
											</div>
					
										</div>
									</template>
								</Table>
							</TabbedViewTab>
							
						</TabbedView>
                	</template>
					<template v-else>
						<div class="alert alert-info">{{$t('no-results')}}</div>
					</template>
                </template>
			</div>
		</div>
        <!--Student Info Modal-->
        <StudentInfo
            :student="currentStudent"
            :role="(this.stations[this.selectedStation]?this.stations[this.selectedStation].role:null)"
            @close="resetStudent"
            @confirm="startOsce"
        ></StudentInfo>
	</div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import TabbedView from "../../components/TabbedView.vue";
import TabbedViewTab from "src/components/TabbedViewTab";
import StudentInfo from "../../components/OSCE/contraptions/StudentInfo.vue";
import OSCEChat from "../../components/OSCE/OSCEChat.vue";

export default {
	components: {
        Table,
        TabbedView,
        TabbedViewTab,
        StudentInfo,
        OSCEChat
	},
    data() {
    
        const today = new Date();
        const past = new Date(today);
        past.setDate(today.getDate() - 31);

        const future = new Date(today);
        future.setDate(today.getDate()+7);    
    
        return {
            ready:false,
            total_count: 0,
            loading: false,
            submitting: false,
            starting: false,
            showadvancedsearch:false,
            students:[],
            visibleStudents:[],
            stations: [],
            selectedStation: 0,
            currentStudent: null,
            filters: {
                search: '',
                status: 0
            },
            statusfilteroptions: [
            	{
            		key: '0',
            		label: 'All'
            	},
            	{
            		key: '1',
            		label: 'Not Started'
            	},
            	{
            		key: '3',
            		label: 'In Progress'
            	},
            	{
            		key: '2',
            		label: 'Completed'
            	},
            	{
            		key: '4',
            		label: 'Aborted'
            	}
            ]
            //item:{}
        }
    },
    mounted() {
    	this.getStations();
    },
    computed: {
        isOsceAdmin() {
            return this.$UserSession.hasPriv.call(this, 'OSCE_ADMIN');
        }
    },
    methods: {
        openTimer(station) {
            const url = this.$router.resolve({ path: `/oscestationtimer/${station.id}` }).href;
            window.open(url, '_blank', 'noopener,noreferrer');
        },
        openRubric(station) {
            const url = this.$router.resolve({ path: `/formeditor/form/${station.form_id}`, query: { viewas: 'submitter' } }).href;
            window.open(url, '_blank', 'noopener,noreferrer');
        },
    	handleNewMessage() {
    	
    	},
    	getStations() {

            return this.$cfetch(`${this.$settings.APIBaseURL}/osce/teacherstations`, {
                data: {
                }
            })
            .then((json) => {
				if (json.status == 'SUCCESS') {
					this.stations = json.stations
					this.ready = true
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
    	
    	},
        statusIcon(item){
            switch(item){
                case 1:
                    return { icon: 'arrow-right-circle-fill', variant: 'primary' };
                case 2:
                    return { icon: 'check-circle-fill', variant: 'success' };
                case 3:
                    return { icon: 'dash-circle-fill', variant: 'info' };
                case 4:
                    return { icon: 'x-circle-fill', variant: 'danger' };
                default: return {}
            }
        },
        statusText(item){
            switch(item.status){
                case 1:
                    return this.$t('not-yet');
                case 2:
                    return this.$t('started') + ' ' + this.$datetime.getLocaleTimeStringFromTimestamp(item.startedtime , false) + ' - '  + this.$t('completed') + ' ' + this.$datetime.getLocaleTimeStringFromTimestamp(item.completedtime , false)
                case 3:
                    return this.$t('started') + ' ' + this.$datetime.getLocaleTimeStringFromTimestamp(item.startedtime , false)
                case 4:
                    return this.$t('aborted');
                default:
                    return this.$t('invalid-status')
            }
        },
        refresh(filters) {
        	this.filters = { ...this.filters, ...filters }
        	this.setVisibleStudents()
        },
        selectStation(index){
        	this.selectedStation = index
        	this.visibleStudents = []
        	this.setVisibleStudents()
        },
        setVisibleStudents() {
        	this.visibleStudents = this.stations[this.selectedStation].students
        	if(this.filters.search){
				const escapeRegExp = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
				this.visibleStudents = this.visibleStudents.filter((student) => {
					return (student.student_id && student.student_id.match(this.filters.search)) || student.student_displayName.match(new RegExp(escapeRegExp(this.filters.search), 'i'));  
				});
        	} else if(this.filters.status != 0) {
				this.visibleStudents = this.visibleStudents.filter((student) => {
					return student.status == this.filters.status
				});
        	}
        },
        chooseStudent(student){
            // The item is the student, so get more data here
            if(this.stations[this.selectedStation] && this.stations[this.selectedStation].role == 'examiner' || student.status == 2 || student.status == 3){
           		this.currentStudent = student
           	} else {
           		this.$notify({
           			type: 'warning',
           			title: this.$t('not-an-examiner'),
           			message: this.$t('not-an-examiner-message'),
           			duration: 4000
           		});
           	}
        },
        resetStudent(){
            this.currentStudent = null
        },
        startOsce(){
        	// a second tap while starting would create a second form response
        	if (this.starting) {
        		return;
        	}
        	if(this.currentStudent.formresponse_id && this.currentStudent.status != 4){
        	
        		// User can only resume thier own stuff.
        		if(this.currentStudent.examiner_id == this.$UserSession.getValue('id') && this.currentStudent.status != 2){
					this.starting = true;
					this.$store.commit("showBlockingSpinner");
					this.$cfetch(`${this.$settings.APIBaseURL}/osce/forms/event/${this.currentStudent.formresponse_id}`, {
						method: 'post',
						data: {
							'event': 'RESUME'
						}
					})
					.then(this.$assertApiSuccess)
					.then(() => {
						this.$store.commit("hideBlockingSpinner");
						this.$router.push(`/osce/form/${this.currentStudent.formresponse_id}`)
					}).catch(error => {
						this.$store.commit("hideBlockingSpinner");
						this.starting = false;
						this.$showApiError(error, { fallback: 'error-saving-osce' });
					});
				} else {
					this.$router.push(`/osce/form/${this.currentStudent.formresponse_id}`)
				}
				
        	} else {
        	
        		this.starting = true;
        		this.$store.commit("showBlockingSpinner");
        		
        		var station = this.stations[this.selectedStation];
        	
        		var data = {
        			formresponse: {
						user_id: this.$UserSession.getValue('id'),
						userfrom_id: this.$UserSession.getValue('id'),
						usersignofffrom_id: this.$UserSession.getValue('id'),
						usersubject_id: this.currentStudent.id ,
						form_id: this.stations[this.selectedStation].form_id ,
						osceevent_id: station.osceevent_id ,
						oscestation_id: station.id ,
						osce_tracknumber: station.tracknumber
        			}
        		}
        	
				this.$cfetch(`${this.$settings.APIBaseURL}/osce/forms/save`, {
					method: 'post',
					data
				})
				.then(this.$assertApiSuccess)
				.then(json => {
					this.$store.commit("hideBlockingSpinner");
					// form saved
					this.$router.push(`/osce/form/${json.formresponse.id}`);
				}).catch(error => {
					this.$store.commit("hideBlockingSpinner");
					this.starting = false;
					this.$showApiError(error, { fallback: 'error-saving-osce' });
				});
			}
        }
    }
};
</script>
